import CategoryList from './CategoryList'

export default CategoryList
